import { createContext } from 'react';

export const IsSsrMobileContext = createContext(false);
